window.wufferaSwipe=function(el,next,prev){
 let start=null;el.querySelectorAll('img').forEach(i=>i.draggable=false);if(el.tagName==='IMG')el.draggable=false;
 el.style.touchAction='pan-y';
 el.addEventListener('pointerdown',e=>{if(e.button!==0)return;start={x:e.clientX,y:e.clientY};el.setPointerCapture(e.pointerId)});
 el.addEventListener('pointerup',e=>{if(!start)return;let x=e.clientX-start.x,y=e.clientY-start.y;start=null;if(Math.abs(x)>30&&Math.abs(x)>Math.abs(y)*1.25)(x<0?next:prev)()});
 el.addEventListener('pointercancel',()=>start=null);
};
document.addEventListener('DOMContentLoaded',()=>{
 document.querySelectorAll('.gallery-thumbs,.shop-thumbnails').forEach(track=>{
  let start=null,moved=false;
  track.querySelectorAll('img').forEach(i=>i.draggable=false);
  track.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0)return;start={x:e.clientX,left:track.scrollLeft};moved=false});
  window.addEventListener('pointermove',e=>{if(!start)return;let delta=e.clientX-start.x;if(Math.abs(delta)>5){moved=true;track.scrollLeft=start.left-delta;e.preventDefault()}});
  window.addEventListener('pointerup',()=>{start=null;setTimeout(()=>moved=false,0)});
  track.addEventListener('click',e=>{if(moved){e.preventDefault();e.stopImmediatePropagation()}},true);
  track.addEventListener('wheel',e=>{if(track.scrollWidth>track.clientWidth&&Math.abs(e.deltaX)>0){track.scrollLeft+=e.deltaX;e.preventDefault()}},{passive:false});
 });
});